module.exports = __webpack_public_path__ + "img/star.492d95e4.svg";